import React, { useEffect, useState } from 'react'


import { deleteCity, deleteUser, loadCitiesWithCount, loadCountriesWithCount } from '../utils/Network'
import { Link } from 'react-router-dom';
import { getDefaultName } from '../utils';
export default function CitiesContent({page}) {

    if(!page)
        page = 1;
    const [loading, setLoading] = useState(0);

    const [cities, setCities] = useState(null);
    const [next, setNext] = useState(null);
    const [previous, setPrevious] = useState(null);
    const [pages, setPages] = useState(null);

    useEffect(() => {
        loadCitiesWithCount(page).then(data => {
            var page_count = parseInt(data.count / 10)+1;
            var pages_array = null;
            if (page_count)
                pages_array = range(1, page_count);
            setPages(pages_array);
            setNext(data.next);
            setPrevious(data.previous);

            if (data.results)
                setCities(data.results);
        });
    }, []);

    function range(start, end) {
        return Array.apply(0, Array(end ))
            .map((element, index) => index + start);
    }

    const handleDelete = (id, e) => {
        setLoading(id);
        deleteCity(id).then(() => {
            loadCitiesWithCount().then(Countries => {
                setCities(Countries);
            });
        })
    }

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        Cities
                        <small>({cities && cities.length}) items</small>
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                        <li className="active">Cities</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">

                                    <div className="card-body">

                                        <table id="example1" className="table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 50 }}>ID</th>
                                                    <th>Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cities && cities.map((item) => (
                                                    <tr key={item.id} className={loading === item.id ? "loading" : ""}>
                                                        <td>{item.id}</td>
                                                        <td>
                                                            <p>{getDefaultName(item.names)}</p>
                                                            <div className="btn-group">
                                                                <button type="button" onClick={(e) => { if (window.confirm('Are you sure you wish to delete this item?')) handleDelete(item.id, e) }} className="btn btn-default btn-sm">
                                                                    <i className="fa fa-trash"></i>
                                                                </button>
                                                                <a href={`/country/${item.id}`} className="btn btn-default btn-sm">
                                                                    <i className="fa fa-edit"></i>
                                                                </a>

                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Name</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>

                                    <div className="card-footer clearfix">
                                        <ul className="pagination cms-pagination m-0 float-right">
                                            <li className="page-item"><Link className="page-link" to="#">«</Link></li>
                                            {pages && pages.map((page_number) => (
                                                <li className="page-item">
                                                    <a className={page_number == page ? "page-link active" : "page-link"} href={`/countries/${page_number}`}>{page_number}</a>
                                                </li>
                                            ))}
                                            <li className="page-item"><Link className= "page-link" to="">»</Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </>



    )
}
